import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';

interface HotelBudgetForecastTableThActionsSignature {
  Args: {
    column: {
      collapseRows: () => void;
      isCollapseDisabled: boolean;
    };
  };
}

const HotelBudgetForecastTableThActions = <template>
  <div class="flex gap-200">
    <PrismButton
      @buttonType="secondary"
      @icon="collapse-all"
      @isDisabled={{@column.isCollapseDisabled}}
      @onClick={{@column.collapseRows}}
      @size="small"
    />
  </div>
</template> satisfies TOC<HotelBudgetForecastTableThActionsSignature>;

export default HotelBudgetForecastTableThActions;
